import { PsHttpService } from '@patsnap/tahiti-core';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { PatSnapSuccessResponseData } from '@patsnap/tahiti-core';
import type {
    ResetTaskApi,
    ResetTaskRequest,
    ResetTaskResponse,
} from '../reset-task-api';
import { coreTelecomApiUrlPrefix } from '@telecom/shared/domain-config';

/**
 * 重置任务API实现
 * @description 实现重置查新任务的API操作
 */
@injectable()
export class ResetTaskApiImpl
    extends PsHttpService
    implements ResetTaskApi {

    get options() {
        return {
            baseURL: coreTelecomApiUrlPrefix,
            headers: {
                'X-API-Version': '2.0',
            },
        };
    }

    /**
     * 重置任务
     * @param data 重置任务请求参数
     * @returns 重置任务的响应结果
     * @description 调用后端API重置指定的查新任务
     */
    async resetTask(data: ResetTaskRequest): Promise<ResetTaskResponse> {
        const result = await this.post<PatSnapSuccessResponseData<ResetTaskResponse>>({
            url: 'novelty-search/reset',
            data,
        });
        return result.data;
    }
}
